import type { ThemeWithoutTokens } from '../theme.types';

export const switchTokens = (theme: ThemeWithoutTokens) =>
  ({
    // toggle
    switchToggleSize: '1rem',
    switchToggleBackground: theme.colors.body.background,
    switchToggleContainerOffset: `${2 / 16}rem`,

    // container
    switchMinWidth: `${44 / 16}rem`,
    switchRadius: theme.typography.lineHeight.s,
    switchLineHeight: theme.typography.lineHeight.s,
    switchTextColor: theme.colors.body.background,
    switchTextPaddingX: theme.space.component.x.s,
    switchFocusShadow: `0 0 0 ${theme.space.component.x.xs} ${theme.palette.blue400Alpha}`,

    // states:
    // normal/unchecked
    switchBackgroundColor: theme.palette.grey400,
    switchDisabledBackgroundColor: theme.palette.grey200,

    // checked
    switchCheckedBackgroundColor: theme.colors.primary.normal,
    switchCheckedDisabledBackgroundColor: theme.palette.blue200,

    // transition
    switchCheckUncheckTransition: `${theme.transition.timings.fast} ${theme.transition.functions.easeFn}`,
  }) as const;
